import React from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import NoSsr from "@mui/material/NoSsr";
import Zoom from "@mui/material/Zoom";
import useScrollTrigger from "@mui/material/useScrollTrigger";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTheme } from "@mui/material/styles";

import FundraiserFooter from "../components/ImprovedShopPage/FundraiserFooter";
import Navbar from "../components/ImprovedShopPage/Navbar";

interface Props {
  children: React.ReactNode;
}

const Layout = ({ children }: Props): JSX.Element => {
  const theme = useTheme();

  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 100,
  });

  const scrollTo = (id: string): void => {
    setTimeout(() => {
      const element = document.querySelector(`#${id}`) as HTMLElement;
      if (!element) {
        return;
      }
      window.scrollTo({ left: 0, top: element.offsetTop, behavior: "smooth" });
    });
  };

  const location = useLocation();
  const isShopPage =
    location.pathname.includes("/participant-shop") ||
    location.pathname.includes("/improved-participant-shop");

  return (
    <Box
      id="page-top"
      sx={{
        backgroundColor: theme.palette.background.default,
        height: "100%",
      }}
    >
      <Navbar />

      <Box
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        width={1}
        margin="0 auto"
      >
        <Box flexGrow={1}>{children}</Box>
        <FundraiserFooter />
      </Box>
      <NoSsr>
        <Zoom in={trigger}>
          <Box
            onClick={() => scrollTo("page-top")}
            role="presentation"
            sx={{ position: "fixed", bottom: 24, right: 32 }}
          >
            <Fab
              color="primary"
              size="small"
              aria-label="scroll back to top"
              sx={{
                color:
                  theme.palette.mode === "dark"
                    ? theme.palette.common.black
                    : theme.palette.common.white,
                "&:hover": {
                  backgroundColor: "transparent",
                  color:
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : theme.palette.success.dark,
                  border: `2px solid ${
                    theme.palette.mode === "dark"
                      ? theme.palette.primary.main
                      : theme.palette.success.dark
                  }`,
                },
              }}
            >
              <KeyboardArrowUpIcon />
            </Fab>
          </Box>
        </Zoom>
      </NoSsr>
    </Box>
  );
};

export default Layout;
